import ParticipantActionButtons from "./ParticipantActionButtons";
import {
  Box,
  Chip,
  Grid,
  ListItem,
  Typography
  } from "@mui/material";
import { calculateAge, formatDate } from "../../../utils/dates";
import { getGenderTranslation } from "../../../interfaces/enums";
import { ParticipantWithId } from "../../../interfaces/IParticipants";
import { Person } from "@mui/icons-material";

interface Props {
  participant: ParticipantWithId;
  isEditingMode: boolean;
  onEdit: () => void;
  onDelete: () => void;
}

export default function ParticipantListItemView({
  participant,
  isEditingMode,
  onEdit,
  onDelete,
}: Props) {
  const age = participant.birthDate ? calculateAge(participant.birthDate) : 0;
  return (
    <ListItem sx={{ py: 2, px: { xs: 2, sm: 3 }, "&:hover": { backgroundColor: "#f9f9f9" } }}>
      <Grid container spacing={2} sx={{ width: "100%" }}>
        <Grid item xs={12} md={8}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Person sx={{ color: "#6366f1", fontSize: 20 }} />
            <Typography variant="h6" sx={{ fontWeight: 600, minWidth: "200px" }}>
              {participant.firstName} {participant.lastName}
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.8rem" }}>
                {formatDate(participant.birthDate)}
              </Typography>
              <Chip
                label={`${age} lat`}
                size="small"
                color="primary"
                sx={{ fontWeight: 500, height: 20, fontSize: "0.7rem" }}
              />
            </Box>
            <Chip
              label={getGenderTranslation(participant.gender)}
              size="small"
              color="default"
              sx={{ fontWeight: 500, height: 20, fontSize: "0.7rem" }}
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={4}>
          <ParticipantActionButtons
            mode="view"
            disabled={isEditingMode}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        </Grid>
      </Grid>
    </ListItem>
  );
}
